let defaultSettings = { namespace: null };

let getSettings = function () {
  if (typeof wB !== 'undefined' && wB) {
    try {
      return wB.getConfig('commonLoggerSettings');
    } catch (err) {
      console.warn('commonLoggerSettings not defined. Self initialized...');
      wB.registerConfig('commonLoggerSettings', defaultSettings);
      return null;
    }
  }
};

const AppServiceLogger = {
  /**
   * log error
   * @param what
   * @param namespace
   * @returns {*}
   */
  error: function (what, namespace) {
    return this.log(what, 'error', namespace);
  },

  /**
   * log warning
   * @param what
   * @param namespace
   * @returns {*}
   */
  warn: function (what, namespace) {
    return this.log(what, 'warn', namespace);
  },

  /**
   * log error
   * @param what
   * @param namespace
   * @returns {*}
   */
  info: function (what, namespace) {
    return this.log(what, 'info', namespace);
  },

  /**
   * logging something
   * @param what
   * @param level
   * @param namespace
   */
  log: function (what, level, namespace) {
    if (typeof what === 'undefined' || !what) {
      return false;
    }

    var resolvedLevel = typeof level === 'undefined' || !level ? 'info' : level;
    var resolvedNamespace = typeof namespace === 'undefined' || !namespace ? 'global' : namespace;

    var settings = getSettings();

    // check for available allowed namespace
    if (settings && typeof settings.namespaces === 'object' && typeof settings.namespaces[resolvedNamespace] !== 'undefined' && !settings.namespaces[resolvedNamespace]) {
      return false;
    }

    resolvedNamespace = resolvedNamespace.toUpperCase();

    var resolvedWhat;

    if (what instanceof Error) {
      resolvedWhat = what.message;
    } else if (typeof what === 'object' && typeof what.length !== 'undefined' && what.length === 1) {
      resolvedWhat = what[0];
    } else {
      resolvedWhat = what;
    }

    switch (resolvedLevel) {
      case 'warn':
        console.warn('[' + resolvedNamespace + '] ', resolvedWhat);
        break;

      case 'error':
        console.error('[' + resolvedNamespace + '] ', resolvedWhat);
        break;

      case 'info':
      default:
        // TODO: create fabric and use external service for logging
        console.log('[' + resolvedNamespace + '] ', resolvedWhat);
        break;
    }

    return this;
  },
};

if (typeof wB !== 'undefined') {
  wB.registerService('logger', function () {
    return AppServiceLogger;
  });
}

export default Object.freeze(AppServiceLogger);
